import React, {useState, useEffect, useRef, useCallback} from 'react';
import L, {map} from 'leaflet';
import {
  MapContainer,
  TileLayer,
  GeoJSON,
  useMapEvents,
  useMap,
} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import {
  MapRightSidebar,
  ModalFlexible,
  CustomZoomControl,
  KeluasanLadang,
  ATD,
  Polyphia,
  UntungRugi,
  DataHasil,
} from '../../components';
import IconMenu from '../../components/IconMenu';
import IconMenuDigitalMapping from '../../components/IconMenuDigitalMapping';

import {Grid, Box, Avatar} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import {IconPoligon, IconWorkReport, Location} from '../../assets';
import axios from 'axios';
import Cookies from 'js-cookie';
import './index.scss';
import uploadMapGenerated from '../../assets/images/uploadMapGenerated.svg';
import iotLogo from '../../assets/images/iotlogo.png';
import {Loader} from '../../components/Loader';
import {Language} from '../../context/LanguageContext';
import {useNavigate, Link} from 'react-router-dom';
import {useTheme} from '@mui/material';
import {DigMap} from '../../context/DigMapContext';
import {Search} from '@material-ui/icons';

const MapGenerated = (props) => {
  const apiUrl = process.env.REACT_APP_MAIN_URL;
  const {language, newObj} = Language();
  const {resetDigMapCtx} = DigMap();
  const tokens_session = Cookies.get('token');
  const navigate = useNavigate();
  const [zoomer, setZoomer] = useState(6);
  const [latlong, setLatlong] = useState([2.208543218591131, 108.03955078125]);
  const [resLuasLadangHa, setResLuasLadangHa] = useState();
  const [resLuasLadangAc, setResLuasLadangAc] = useState();
  const [resLuasBerhasil, setResLuasBerhasil] = useState();
  const [resLuasBertanam, setResLuasBertanam] = useState();
  const [mapData, setMapData] = useState([]);
  const [geoJsonLayer, setGeoJsonLayer] = useState(null);
  const [groupName, setGroupName] = useState();
  const [useGroupName, setUseGroupName] = useState(false);
  const [tempNumber, setTempNumber] = useState();
  const [selectedFeature, setSelectedFeature] = useState(null);
  const [highlightLayer, setHighlightLayer] = useState(null);
  const [tempWeather, setTempWeather] = useState();
  const [pkCode, setPkCode] = useState();
  const [negeriCode, setNegeriCode] = useState();
  const [projectCode, setProjectCode] = useState();
  const [wilayahCode, setWilayahCode] = useState();
  const [newWilayahCode, setNewWilayahCode] = useState();
  const [iotDevice, setIotDevice] = useState();
  const [payload, setPayload] = useState({
    menu: {label: 'Keluasan Ladang', value: 'keluasan_ladang'},
  });
  const [modal, setModal] = useState('hidden');

  const handleRenderModal = useCallback(() => {
    switch (modal) {
      case 'mapSearch':
        return (
          <ModalFlexible
            type={modal}
            data={{
              mapRef: mapRef,
              getMapData: getMapData,
              setMarkerClick: setMarkerClick,
              setPkCode: setPkCode,
              setProjectCode: setProjectCode,
            }}
            onClose={() => {
              setModal('hidden');
            }}
          />
        );
      default:
        return;
    }
  }, [modal]);
  const emptyFilter = {
    switch1: false,
    switch2: false,
    switch3: false,
    switch4: false,
    switch5: false,
    switch6: false,
    switch7: false,
  };
  const [selectedFilter, setSelectedFilter] = useState({
    switch7: true,
    switch6: false,
    switch5: false,
    switch4: false,
    switch3: true,
    switch2: false,
    switch1: true,
  });

  const [filter, setFilter] = useState(0);

  const [tempDataPokok, setTempDataPokok] = useState();
  const [tempJaringanJalan, setTempJaringanJalan] = useState();
  const [tempBlokAgronomi, setTempBlokAgronomi] = useState();
  const [tempPerimeterLadang, setTempPerimeterLadang] = useState();
  const [tempGunaTanah, setTempGunaTanah] = useState();
  const [tempTerlebihTanam, setTempTerlebihTanam] = useState();
  const [tempIoT, setTempIoT] = useState();
  const [rightData, setRightData] = useState();

  const [centeredLatLong, setCenteredLatLong] = useState();
  const [timeoutId, setTimeoutId] = useState(null);
  const [isLoad, setLoad] = useState(false);
  const [bounds, setBounds] = useState(false);

  const role = props.role;
  const adminRoleDigitalMap = ['digital_mapping_admin'];
  const adminRoleLintramax = ['lintramax_admin'];
  const adminRoleIot = ['iot_admin'];
  const viewerRoleDigitalMap = ['digital_mapping_viewer'];
  const viewerRoleLintramax = ['lintramax_viewer'];
  const viewerRoleIot = ['iot_viewer'];

  const adminFlag = role?.some((value) => adminRoleDigitalMap.includes(value));
  const adminIotFlag = role?.some((value) => adminRoleIot.includes(value));
  const adminLintramaxFlag = role?.some((value) =>
    adminRoleLintramax.includes(value)
  );
  const viewerDigitalMapFlag = role?.some((value) =>
    viewerRoleDigitalMap.includes(value)
  );
  const viewerLintramaxFlag = role?.some((value) =>
    viewerRoleLintramax.includes(value)
  );
  const viewerIotFlag = role?.some((value) => viewerRoleIot.includes(value));

  const [loopFlag, setLoopFlag] = useState(0);
  const [flag, setFlag] = useState();
  const [tempArr, setTempArr] = useState([]);
  const [selectedFilterClone, setSelectedFilterClone] = useState({
    switch7: true,
    switch6: false,
    switch5: false,
    switch4: false,
    switch3: true,
    switch2: false,
    switch1: true,
  });
  const [initialized, setInitialized] = useState(false);
  const [isMarkerClick, setMarkerClick] = useState(false);
  const [isPolyExist, setPolyExist] = useState(false);
  const [displayCode, setDisplayCode] = useState(false);
  const rasterRef = useRef();
  const blokAgronomiRef = useRef();
  const jaringanJalanRef = useRef();
  const dirianPokokRef = useRef();
  const mapRef = useRef();

  useEffect(() => {
    if (zoomer >= 16) setLoopFlag(1);
  }, [zoomer]);

  useEffect(() => {
    let arr = {};
    if (loopFlag === 1) {
      arr = {
        // switch7: true,
        switch6: false,
        switch5: false,
        switch4: false,
        switch3: true,
        switch2: false,
        switch1: true,
      };
    } else if (loopFlag === 2) {
      arr = {
        // switch7: true,
        switch6: false,
        switch5: true,
        switch4: false,
        switch3: true,
        switch2: true,
        switch1: false,
      };
    } else if (loopFlag === 3) {
      arr = {
        // switch7: true,
        switch6: false,
        switch5: true,
        switch4: true,
        switch3: true,
        switch2: false,
        switch1: false,
      };
    }
    setSelectedFilter((prev) => ({...prev, ...arr}));
    setFlag(-1);
  }, [loopFlag]);
  useEffect(() => {
    if (flag === -1) {
      setSelectedFilterClone(emptyFilter);
      setFlag(flag + 1);
    } else if (tempArr?.length > flag) {
      const obj = {...selectedFilterClone, [tempArr[flag]]: true};
      setSelectedFilterClone(obj);
      setFlag(flag + 1);
    } else {
      setFlag(100);
      setTempArr();
    }
  }, [flag]);

  useEffect(() => {
    if (flag === -1) {
      const indexArray = [];
      for (const key in selectedFilter) {
        if (selectedFilter.hasOwnProperty(key) && selectedFilter[key]) {
          indexArray.push(key);
        }
      }

      const revArr = indexArray.sort((a, b) => b.localeCompare(a));
      setTempArr(revArr);
    }
  }, [selectedFilter, flag]);

  function handleTabSwitch(data) {
    setTempNumber(data);
    getRightSideData(data, centeredLatLong, bounds);

    setFilter(data);
    setLoopFlag(data + 1);
  }

  const resetCtx = () => {
    resetDigMapCtx();
  };

  const handleSwitchChange = async (switchValues) => {
    setFlag(-1);
    setSelectedFilter(switchValues);
    // if (switchValues.switch1 === true) {
    //   const findKey = await findKeyByProjectName(
    //     groupName,
    //     rightData.detail.kodKawasa
    //   );
    //   downloadDirianPokok(findKey);
    // }
  };

  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutId]);

  const newCenterHandler = (map) => {
    const newWidth = window.innerWidth;
    const container =
      document
        .getElementsByClassName('dataContainer')[0]
        .getBoundingClientRect().width + 10;

    const perbandingan = parseFloat((newWidth - container) / newWidth);
    const newCenterX =
      ((map.getBounds()._northEast.lng - map.getBounds()._southWest.lng) *
        perbandingan) /
      2;

    let newCenterLng = map.getBounds().getCenter();

    newCenterLng.lng = newCenterX + map.getBounds()._southWest.lng;

    return newCenterLng;
  };

  function MapFunctionality() {
    const map = useMapEvents({
      click: (e) => {
        setLatlong([e.latlng.lat, e.latlng.lng]);
        map.locate();
      },
      zoomend: (e) => {
        const currentZoom = e.target.getZoom();
        setZoomer(e.target.getZoom());
        // console.log(isMarkerClick, currentZoom, zoomer);
        if (currentZoom >= 10 && currentZoom < 12) {
          setPkCode();
          setIotDevice();
          setUseGroupName(false);
        } else if (currentZoom >= 8 && currentZoom < 10) {
          setNegeriCode();
          setUseGroupName(false);
        } else if (currentZoom < 8) {
          setNewWilayahCode();
          setWilayahCode();
          setUseGroupName(false);
        }

        if (currentZoom < 15) {
          setFlag(1);
        }

        if (
          (currentZoom === 17 && zoomer < currentZoom && isPolyExist) ||
          currentZoom < 15 ||
          // (currentZoom === 15 && zoomer > currentZoom) ||
          (currentZoom === 16 && zoomer > currentZoom && isPolyExist) ||
          isMarkerClick
        ) {
          getMapData(
            e.target.getBounds(),
            e.target.getZoom(),
            e.target.getBounds().getCenter()
          );
        }

        setMarkerClick(false);
      },
      moveend: (e) => {
        // handleMoveEnd(e);
        // console.log("getBounds", e.target.getBounds());
      },
    });

    const earlyBounds = map.getBounds();
    useEffect(() => {
      if (initialized === false) {
        const centerNew =
          window.innerWidth < 576
            ? map.getBounds().getCenter()
            : newCenterHandler(map);
        getMapData(earlyBounds, map.getZoom(), centerNew);
        setInitialized(true);
      }
    }, []);
    return null;
  }

  useEffect(() => {
    if (tempBlokAgronomi) setPolyExist(true);
    else setPolyExist(false);
  }, [tempBlokAgronomi]);

  useEffect(() => {
    if (
      rasterRef.current &&
      blokAgronomiRef.current &&
      (tempBlokAgronomi ||
        tempJaringanJalan ||
        tempPerimeterLadang ||
        tempGunaTanah ||
        tempDataPokok)
    ) {
      blokAgronomiRef.current.bringToFront();
      jaringanJalanRef.current?.bringToFront();
      rasterRef.current?.bringToFront();
      dirianPokokRef.current?.bringToFront();
    }
  }, [
    rasterRef.current,
    blokAgronomiRef.current,
    jaringanJalanRef.current,
    dirianPokokRef.current,
  ]);

  const callWeather = async (data) => {
    try {
      const res = await axios.post(
        `${apiUrl}/mapping/open-weather`,
        {
          latitude: data.nearest_latitude,
          longitude: data.nearest_longitude,
        },
        {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );
      if (res.status === 200) {
        setTempWeather(res?.data?.data);
      }
      return res.data;
    } catch (e) {
      console.log(e);
    }
  };

  const OnFeature = (feature, layer) => {
    const map = useMap();

    layer.on('click', (e) => {
      setMarkerClick(true);
      let zoomPlus;
      if (map.getZoom() >= 14) {
        zoomPlus = 17;
      } else if (map.getZoom() === 18) zoomPlus = 18;
      else {
        zoomPlus = map.getZoom() + 2;
      }
      if (zoomPlus >= 8 && zoomPlus < 10) {
        setWilayahCode(feature?.properties?.id);
        setNewWilayahCode(feature?.properties?.code);
      } else if (zoomPlus >= 12 && zoomPlus < 14) {
        setPkCode(feature?.properties?.code);
        // callIotDevice(feature?.properties?.code, 'pk_code');
      } else if (zoomPlus >= 10 && zoomPlus < 12) {
        // console.log(feature?.properties?.code);
        setPkCode();
        setNegeriCode(feature?.properties?.code);
      } else if (zoomPlus >= 14) {
        setProjectCode(feature?.properties?.code);
      }

      map.flyTo(
        [feature.properties.latitude, feature.properties.longitude],
        zoomPlus
      );
      if (map.getZoom() >= 14) {
        setGroupName(feature.properties.name);
        setUseGroupName(true);
      } else {
        // for when zoom to lvl 13 the marker not removed
        if (map.getZoom < 13) {
          map.eachLayer((layer) => {
            if (layer instanceof L.Marker) {
              map.removeLayer(layer);
            }
          });
        }
        setTempDataPokok();
        setTempJaringanJalan();
        setTempBlokAgronomi();
        setTempPerimeterLadang();
        setTempGunaTanah();
        setTempTerlebihTanam();
        setTempIoT();
      }
    });
  };

  const onFeatureIoTDigitalMap = (feature, layer) => {
    layer.on('click', (e) => {
      navigate(`/iotgraph?id=${feature.properties.id}`);
    });
  };

  const [doughnutData, setDoughnutData] = useState({
    labels: ['Luas Berhasil', 'Luas Bertanam'],
    datasets: [
      {
        label: 'Data',
        data: [1, 1],
        backgroundColor: ['rgba(43, 51, 125, 1)', 'rgba(226, 31, 38, 1)'],
        borderColor: ['rgba(43, 51, 125, 1)', 'rgba(226, 31, 38, 1)'],
        borderWidth: 1,
      },
    ],
  });

  // MAP LOADER FUNCTION
  const getMapData = useCallback(
    async (data, zoom, center, code) => {
      setLoad(true);
      var url = '';
      var properties = {
        flag: 'drag',
      };
      if (zoom >= 6) {
        url = `${apiUrl}/area/wilayah/get`;
        properties = {
          flag: 'drag',
          latitude_x: data._southWest.lat,
          longitude_x: data._southWest.lng,
          latitude_y: data._northEast.lat,
          longitude_y: data._northEast.lng,
        };
        setDisplayCode(false);
      }
      if (zoom >= 8) {
        url = `${apiUrl}/area/negeri/get-by-wilayah`;
        properties = {
          flag: 'drag',
          latitude_x: data._southWest.lat,
          longitude_x: data._southWest.lng,
          latitude_y: data._northEast.lat,
          longitude_y: data._northEast.lng,
        };
        setDisplayCode(true);
      }
      if (zoom >= 10) {
        url = `${apiUrl}/mapping/pk-code/get-by-negeri-new`;
        if (negeriCode)
          properties = {
            flag: 'click',
            code: negeriCode,
            status: 'publish',
          };
        else
          properties = {
            flag: 'drag',
            // code: "06",
            latitude_x: data._southWest.lat,
            longitude_x: data._southWest.lng,
            latitude_y: data._northEast.lat,
            longitude_y: data._northEast.lng,
            status: 'publish',
          };
        setDisplayCode(false);
      }
      if (zoom >= 12) {
        url = `${apiUrl}/mapping/project-code/get-by-pk-code-new`;
        if (pkCode || code)
          properties = {
            flag: 'click',
            code: code ? code : pkCode,
            status: 'publish',
          };
        else
          properties = {
            flag: 'drag',
            latitude_x: data._southWest.lat,
            longitude_x: data._southWest.lng,
            latitude_y: data._northEast.lat,
            longitude_y: data._northEast.lng,
            status: 'publish',
          };
        setDisplayCode(false);
      }
      if (zoom > 14 || (zoom === 14 && isPolyExist)) {
        url = `${apiUrl}/mapping/collect-map-new`;
        properties = {
          input_params: 'null',
          target: 'all',
          latitude_x: data._southWest.lat,
          longitude_x: data._southWest.lng,
          latitude_y: data._northEast.lat,
          longitude_y: data._northEast.lng,
          groupname: useGroupName ? groupName : null,
          center_lat: center.lat,
          center_long: center.lng,
          status: 'publish',
          only_blok_agronomi: zoom >= 17 ? false : true,
        };
        setDisplayCode(false);
      }
      try {
        const res = await axios.post(url, properties, {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        });
        if (res.data.status === 200) {
          if (res.data.polyphia === true) {
            setTempDataPokok();
            setTempJaringanJalan();
            setTempBlokAgronomi();
            setTempPerimeterLadang();
            setTempGunaTanah();
            setTempTerlebihTanam();
            setTempIoT();
            setGroupName(res.data.data.groupname);
            setUseGroupName(false);
            getRightSideData(tempNumber, center, data);
            setCenteredLatLong(center);
            setBounds(data);
            setRightData(res?.data?.data);
            // const findKey = await findKeyByProjectName(
            //   res.data.data.groupname,
            //   res.data.data.detail.kodKawasa
            // );
            // downloadDirianPokok(findKey);

            for (let i = 0; i < res?.data?.data?.data?.length; i++) {
              const data = res?.data?.data?.data[i];

              if (data?.name === 'Jaringan Jalan') {
                setTempJaringanJalan(data);
              }

              if (data?.name === 'Blok Agronomi') {
                setTempBlokAgronomi(data);
              }

              if (data?.name === 'Perimeter Ladang') {
                setTempPerimeterLadang(data);
              }

              if (data?.name === 'Gunatanah') {
                setTempGunaTanah(data);
              }

              if (data?.name === 'Terlebih Tanam') {
                setTempTerlebihTanam(data);
              }

              if (data?.name === 'IoT') {
                setTempIoT(data);
              }
            }
          } else {
            console.log('no polyphia');
            setGeoJsonLayer();
            setMapData(res?.data?.data);
          }
        } else {
          console.log('no data');
        }
        if (res.data.status === 401) {
          Cookies.remove('token');
          // destroyCookie(null, 'token');
          navigate('/login');
        }

        if (zoom > 14) {
          setFlag(-1);
        }
        setLoad(false);
        return res.data;
      } catch (e) {
        setLoad(false);
        console.log(e);
      }
    },
    [
      mapData,
      pkCode,
      negeriCode,
      projectCode,
      wilayahCode,
      newWilayahCode,
      groupName,
      tempNumber,
    ]
  );

  const findKeyByProjectName = async (name, pk) => {
    const jsonFile = await getDirianJSONFile(pk);
    const project = jsonFile.find((proj) => proj.namaProjek === name);
    return project ? project.key : null;
  };

  const callIotDevice = async (code, flag) => {
    try {
      const res = await axios.post(
        `${apiUrl}/device/list`,
        {
          flag: flag,
          value: code,
        },
        {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      const filteredDataFeature = res.data.data.map((obj) => {
        return {
          type: 'Feature',
          properties: {
            name: obj.title,
            id: obj.id,
            latitude: obj.latitude,
            longitude: obj.longitude,
            pk_code: obj.pk_code,
            project_code: obj.project_code,
            total_area_ha: obj.total_area_ha,
            type: obj.type,
          },
          geometry: {
            type: 'Point',
            coordinates: [obj.longitude, obj.latitude],
          },
        };
      });
      const result = {
        type: 'FeatureCollection',
        features: filteredDataFeature,
      };

      setIotDevice(result);
    } catch (error) {
      console.log(error);
    }
  };

  const getRightSideData = async (number, center, bounds) => {
    var target = '';
    if (number === 0 || number === undefined || number === null) {
      target = 'Dirian Pokok';
    }
    if (number === 1) {
      target = 'Jalan';
    }
    if (number === 2) {
      target = 'Guna Tanah';
    }
    try {
      const res = await axios.post(
        `${apiUrl}/mapping/collect-data-new`,
        {
          // groupname: groupname,
          target: target,
          latitude_x: bounds._southWest.lat,
          longitude_x: bounds._southWest.lng,
          latitude_y: bounds._northEast.lat,
          longitude_y: bounds._northEast.lng,
          center_lat: center.lat,
          center_long: center.lng,
          status: 'publish',
        },
        {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );
      if (res.status === 200) {
        console.log(res.data.data, 'res');
        setMapData(res.data);
        callWeather(res.data?.data?.groupname_detail);
      }
      return res.data;
    } catch (e) {
      console.log(e);
    }
  };

  const getDirianJSONFile = async (pkcode) => {
    try {
      const res = await axios.post(
        `${apiUrl}/mapping/project_code/get-all-by-pk-code-new`,
        {
          pk_code: pkcode,
          status: 'publish',
        },
        {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      return res.data;
    } catch (e) {
      console.log(e);
    }
  };
  const downloadDirianPokok = async (key) => {
    try {
      const res = await axios.post(
        `${apiUrl}/mapping/geojson/download`,
        {
          key: key,
        },
        {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      if (res.status === 200) {
        setTempDataPokok(res.data);
      }
      return res.data;
    } catch (e) {
      console.log(e);
    }
  };

  const handleRenderSidebar = useCallback(
    (type) => {
      switch (type) {
        case 'keluasan_ladang':
          return (
            <KeluasanLadang
              mapData={mapData}
              doughnutData={doughnutData}
              resLuasLadangHa={resLuasLadangHa}
              resLuasLadangAc={resLuasLadangAc}
              resLuasBerhasil={resLuasBerhasil}
              resLuasBertanam={resLuasBertanam}
              groupName={groupName}
              zoomer={zoomer}
              mapRef={mapRef}
              setPkCode={setPkCode}
              setNegeriCode={setNegeriCode}
              setProjectCode={setProjectCode}
              setMarkerClick={setMarkerClick}
            />
          );
        case 'data_hasil':
          return (
            <DataHasil
              mapRef={mapRef}
              wilayahCode={newWilayahCode}
              negeriCode={negeriCode}
              pkCode={pkCode}
              projectCode={projectCode}
              zoomer={zoomer}
            />
          );
        case 'untung_&_rugi':
          return (
            <UntungRugi
              zoomer={zoomer}
              negeriCode={negeriCode}
              pkCode={pkCode}
              projectCode={projectCode}
              wilayahCode={newWilayahCode}
              mapRef={mapRef}
              setPkCode={setPkCode}
              setNegeriCode={setNegeriCode}
              setProjectCode={setProjectCode}
              setMarkerClick={setMarkerClick}
              geoJsonLayer={geoJsonLayer}
            />
          );
        case 'analisis_tanah_&_daun':
          return (
            <ATD
              zoomer={zoomer}
              negeriCode={negeriCode}
              pkCode={pkCode}
              projectCode={projectCode}
              wilayahCode={wilayahCode}
              mapRef={mapRef}
              setPkCode={setPkCode}
              setNegeriCode={setNegeriCode}
              setProjectCode={setProjectCode}
              setMarkerClick={setMarkerClick}
            />
          );
        default:
          return (
            <KeluasanLadang
              mapData={mapData}
              doughnutData={doughnutData}
              resLuasLadangHa={resLuasLadangHa}
              resLuasLadangAc={resLuasLadangAc}
              resLuasBerhasil={resLuasBerhasil}
              resLuasBertanam={resLuasBertanam}
              groupName={groupName}
              zoomer={zoomer}
              mapRef={mapRef}
              setPkCode={setPkCode}
              setNegeriCode={setNegeriCode}
              setProjectCode={setProjectCode}
              setMarkerClick={setMarkerClick}
            />
          );
      }
    },
    [
      payload,
      mapData,
      doughnutData,
      zoomer,
      groupName,
      resLuasLadangHa,
      resLuasLadangAc,
      resLuasBerhasil,
      resLuasBertanam,
      setPkCode,
      setNegeriCode,
      setProjectCode,
      setMarkerClick,
    ]
  );
  useEffect(() => {
    if (mapData.length > 0) {
      const geoJsonFeatures = mapData.map((item) => ({
        type: 'Feature',
        properties: {
          name: item.title,
          id: item.id,
          latitude: item.latitude,
          longitude: item.longitude,
          code: item.code,
          wilayah_id: item.wilayah_id,
        },
        geometry: {
          type: 'Point',
          coordinates: [item.longitude, item.latitude],
        },
      }));
      const geoJson = {
        type: 'FeatureCollection',
        features: geoJsonFeatures,
      };
      setGeoJsonLayer(geoJson);
      setResLuasLadangHa(
        mapData.reduce((sum, obj) => sum + obj.luas_ladang_ha, 0).toFixed(2)
      );
      setResLuasLadangAc(
        mapData.reduce((sum, obj) => sum + obj.luas_ladang_ac, 0).toFixed(2)
      );
      setResLuasBerhasil(
        mapData.reduce((sum, obj) => sum + obj.luas_berhasil, 0).toFixed(2)
      );
      setResLuasBertanam(
        mapData.reduce((sum, obj) => sum + obj.luas_bertanam, 0).toFixed(2)
      );

      setDoughnutData({
        labels: ['Luas Berhasil', 'Luas Bertanam'],
        datasets: [
          {
            label: 'Data',
            data: [
              mapData.reduce((sum, obj) => sum + obj.luas_berhasil, 0),
              mapData.reduce((sum, obj) => sum + obj.luas_bertanam, 0),
            ],
            backgroundColor: ['rgba(43, 51, 125, 1)', 'rgba(226, 31, 38, 1)'],
            borderColor: ['rgba(43, 51, 125, 1)', 'rgba(226, 31, 38, 1)'],
            borderWidth: 1,
          },
        ],
      });
    }
  }, [mapData]);

  useEffect(() => {
    if (zoomer <= 14) {
      setTempDataPokok();
      setTempJaringanJalan();
      setTempBlokAgronomi();
      setTempPerimeterLadang();
      setTempGunaTanah();
      setTempTerlebihTanam();
      setTempIoT();
    }
  }, [zoomer]);

  const pointToLayer = (feature, latlng) => {
    const displayTooltipCode =
      displayCode === true ? feature.properties.code : '';
    const icon = L.icon({
      iconUrl: Location,
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      tooltipAnchor: [10, -20],
    });
    const tooltip = L.tooltip({
      direction: 'right',
      permanent: 'true',
      opacity: 1,
      arrow: false,
      interactive: true,
      className: 'custom-tooltip',
      riseOffset: 800,
      riseOnHover: true,
    }).setContent(displayTooltipCode + ' ' + feature.properties.name);
    const marker = L.marker(latlng, {
      icon,
      className: 'custom-tooltip',
      riseOnHover: true,
    }).bindTooltip(tooltip);

    return marker;
  };

  const handleFeatureClick = async (event, layer, feature) => {
    setSelectedFeature(layer.feature);

    // Remove the existing highlight layer if it exists
    if (highlightLayer) {
      map.removeLayer(highlightLayer);
    }
    // Create a new highlight layer for the clicked feature
    let newHighlightLayer;
    const {lat, lng} = layer.getCenter();
    mapRef.current.flyTo([lat, lng], mapRef.current.getZoom());

    if (
      (layer.feature.geometry.type === 'Polygon' ||
        layer.feature.geometry.type === 'MultiPolygon') &&
      feature
    ) {
      let defaultColor = feature.color;
      setTimeout(() => {
        setSelectedFeature();
      }, 2000);
    } else if (layer.feature.geometry.type === 'Point') {
      const latlng = layer.getLatLng();
      const radius = 10; // set the radius of the buffer zone in pixels
      newHighlightLayer = L.circle(latlng, {
        radius,
        fillColor: 'green',
        fillOpacity: 0.6,
        stroke: false,
      });
      // .addTo(map);
    }
  };

  const mapMarginTop = document.getElementsByClassName('headerFelcra')[0]
    ? document.getElementsByClassName('headerFelcra')[0].getBoundingClientRect()
        .height
    : 60;

  return (
    <div>
      {isLoad && (
        <div style={{position: 'absolute'}}>
          <Loader />
        </div>
      )}
      <div
        className='MapGeneratedMain'
        style={{
          marginTop: mapMarginTop,
          height: `calc(100vh - ${mapMarginTop})`,
        }}
      >
        <MapContainer
          center={[2.208543218591131, 108.03955078125]}
          zoom={zoomer}
          className='mapContainer'
          zoomControl={false}
          ref={mapRef}
          minZoom={6}
          maxZoom={17}
        >
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
            zIndex={10}
          />
          {selectedFilter.switch7 && (
            <TileLayer
              url={`${process.env.REACT_APP_S3_PUBLIC_URL}/${pkCode}/raster/{z}/{x}/{y}.png`}
              attribution='Generated by TilesXYZ'
              zIndex={21}
              ref={rasterRef}
            />
          )}
          <MapFunctionality />
          <div className='mapWrapper'>
            {geoJsonLayer && (
              <GeoJSON
                data={geoJsonLayer}
                pointToLayer={pointToLayer}
                onEachFeature={OnFeature}
              ></GeoJSON>
            )}

            {zoomer < 17 ? (
              <>
                {selectedFilterClone?.switch3 && (
                  <>
                    {tempBlokAgronomi && (
                      <>
                        <GeoJSON
                          ref={blokAgronomiRef}
                          data={tempBlokAgronomi}
                          style={(feature) => ({
                            fillColor:
                              selectedFeature === feature
                                ? '#00ffff40'
                                : `rgba(${feature.color})`,
                            fillOpacity: 0.4,
                            lineCap: 'butt',
                            lineJoin: 'miter',
                            // color: `rgba(${feature.color})`,
                            color:
                              selectedFeature === feature
                                ? 'rgba(0, 255, 255, 2)'
                                : `rgba(${feature.color})`,
                            weight: 1,
                          })}
                          onEachFeature={(feature, layer) => {
                            layer.options.layerName = 'B2';
                            layer.on({
                              click: (event) => {
                                handleFeatureClick(event, layer, feature);
                              },
                            });
                          }}
                        />
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <>
                {selectedFilterClone?.switch1 && (
                  <>
                    {tempDataPokok && (
                      <GeoJSON
                        data={tempDataPokok}
                        pointToLayer={(feature, latlng) => {
                          return L.circleMarker(latlng, {
                            radius: feature.size,
                            fillColor: `rgba(${feature.outline_color})`,
                            color: `rgba(${feature.color})`,
                            opacity: feature.alpha,
                          });
                        }}
                        onEachFeature={(feature, layer) => {
                          layer.on({
                            click: (event) => {
                              handleFeatureClick(event, layer);
                            },
                          });
                        }}
                        ref={dirianPokokRef}
                      />
                    )}
                  </>
                )}
                {selectedFilterClone?.switch2 && (
                  <>
                    {tempJaringanJalan && (
                      <>
                        <GeoJSON
                          ref={jaringanJalanRef}
                          data={tempJaringanJalan}
                          style={(feature) => ({
                            color: '#000000',
                            weight: 2,
                            opacity: feature.alpha,
                            dashArray: [5, 10],
                            dashOffset: 0,
                            lineCap: 'round',
                            lineJoin: 'round',
                          })}
                        />
                      </>
                    )}
                  </>
                )}
                {selectedFilterClone?.switch3 && (
                  <>
                    {tempBlokAgronomi && (
                      <>
                        <GeoJSON
                          ref={blokAgronomiRef}
                          data={tempBlokAgronomi}
                          style={(feature) => ({
                            fillColor:
                              selectedFeature === feature
                                ? '#00ffff40'
                                : `rgba(${feature.color})`,
                            fillOpacity: 0.4,
                            lineCap: 'butt',
                            lineJoin: 'miter',
                            // color: `rgba(${feature.color})`,
                            color:
                              selectedFeature === feature
                                ? 'rgba(0, 255, 255, 2)'
                                : `rgba(${feature.color})`,
                            weight: 1,
                          })}
                          onEachFeature={(feature, layer) => {
                            layer.options.layerName = 'B2';
                            layer.on({
                              click: (event) => {
                                handleFeatureClick(event, layer, feature);
                              },
                            });
                          }}
                        />
                      </>
                    )}
                  </>
                )}
                {selectedFilterClone?.switch4 && (
                  <>
                    {tempPerimeterLadang && (
                      <>
                        <GeoJSON
                          data={tempPerimeterLadang}
                          style={(feature) => ({
                            fillColor: `rgba(${feature.color})`,
                            fillOpacity: 0.4,
                            lineCap: 'butt',
                            lineJoin: 'miter',
                            color: `rgba(${feature.outline_color})`,
                            weight: 1,
                          })}
                        />
                      </>
                    )}
                  </>
                )}
                {selectedFilterClone?.switch5 && (
                  <>
                    {tempGunaTanah && (
                      <>
                        <GeoJSON
                          data={tempGunaTanah}
                          style={(feature) => ({
                            fillColor: `rgba(${feature.color})`,
                            fillOpacity: feature.alpha,
                            lineCap: 'butt',
                            lineJoin: 'miter',
                            color: `rgba(${feature.outline_color})`,
                            weight: 1,
                          })}
                        />
                      </>
                    )}
                  </>
                )}
                {selectedFilterClone?.switch6 && (
                  <>
                    {tempTerlebihTanam && tempTerlebihTanam.features && (
                      <>
                        <GeoJSON
                          data={tempTerlebihTanam}
                          style={(feature) => ({
                            fillColor: `rgba(${feature.color})`,
                            fillOpacity: feature.alpha,
                            lineCap: 'butt',
                            lineJoin: 'miter',
                            color: `rgba(${feature.outline_color})`,
                            weight: 1,
                          })}
                        />
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </div>
          {selectedFilter.switch1 && (
            <TileLayer
              className='transparent'
              url={`${process.env.REACT_APP_S3_PUBLIC_URL}/${pkCode}/dirian_pokok/{z}/{x}/{y}.png`}
              attribution='Generated by TilesXYZ'
              zIndex={22}
              ref={dirianPokokRef}
            />
          )}
        </MapContainer>
        <CustomZoomControl lat={latlong[0]} lng={latlong[1]} mapRef={mapRef} />
        <div
          style={{
            position: 'static',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box className='topHeader' px={2}>
            <Box display='flex' style={{padding: '10px'}}>
              <Link
                to='/'
                style={{
                  textDecoration: 'none',
                  alignItems: 'center',
                  display: 'flex',
                }}
                onClick={() => resetCtx()}
              >
                <ChevronLeftIcon style={{fontSize: '28px', color: '#2B337D'}} />
                <div
                  style={{
                    color: '#2B337D',
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: '24px',
                    fontWeight: 'bold',
                  }}
                >
                  {newObj.DigitalMappingWord[language]}
                </div>
              </Link>
            </Box>

            <Box className='topHeaderAction'>
              {adminFlag && (
                <>
                  <div className='adminMenu'>
                    <Link to='/uploadmap' className='adminMenuItem'>
                      <Avatar
                        alt='Upload Map'
                        sx={{
                          width: 24,
                          height: 24,
                          marginRight: '10px',
                        }}
                        src={uploadMapGenerated}
                      />

                      {newObj.UploadMapWord[language]}
                    </Link>

                    <Link to='/mapfiles' className='adminMenuItem'>
                      <img
                        alt='Map Files'
                        style={{
                          width: 24,
                          height: 24,
                          marginRight: '10px',
                          fill: '#fff !important',
                        }}
                        src={IconPoligon}
                      />
                      {newObj.MapFilesWord[language]}
                    </Link>
                  </div>

                  <div className='adminMenuSmall'>
                    <IconMenuDigitalMapping />
                  </div>
                </>
              )}
              <div className='actionItem'>
                <Search onClick={() => setModal('mapSearch')} />
              </div>
              <div className='actionItem'>
                <Link to={'/laporan-kerja'}>
                  <img
                    src={IconWorkReport}
                    alt='icon'
                    style={{
                      width: '16px',
                      height: '16px',
                    }}
                  />
                </Link>
              </div>
              <div className='actionItem'>
                <IconMenu
                  onSwitchChange={handleSwitchChange}
                  zoom={zoomer}
                  changeSwitchValue={selectedFilter}
                  filter={filter}
                />
              </div>
            </Box>
          </Box>
        </div>
        {mapData.polyphia !== true ? (
          <Grid className='dataContainer'>
            <MapRightSidebar menu={payload.menu} setMenu={setPayload}>
              {handleRenderSidebar(payload.menu.value)}
            </MapRightSidebar>
          </Grid>
        ) : (
          <Grid className='dataContainer'>
            <Polyphia
              mapRef={mapRef}
              mapData={mapData}
              rightData={rightData}
              viewerLintramaxFlag={viewerLintramaxFlag}
              viewerDigitalMapFlag={viewerDigitalMapFlag}
              viewerIotFlag={viewerIotFlag}
              adminFlag={adminFlag}
              adminIotFlag={adminIotFlag}
              adminLintramaxFlag={adminLintramaxFlag}
              groupName={groupName}
              handleTabSwitch={handleTabSwitch}
              tempWeather={tempWeather}
              wilayahCode={wilayahCode}
              newWilayahCode={newWilayahCode}
              negeriCode={negeriCode}
              pkCode={pkCode}
              projectCode={projectCode}
              zoomer={zoomer}
            />
          </Grid>
        )}
      </div>
      {handleRenderModal()}
    </div>
  );
};

export default MapGenerated;
